




















import Vue from "vue";
import REGISTRATION_QUERY from "@/graphql/RegistrationQuery.gql";
import SessionAttendance from "@/components/SessionAttendance.vue";
import {
  RegistrationQuery_registrations,
  RegistrationQueryVariables
} from "@/graphql/generatedTypes/RegistrationQuery";
import { AlertBar } from "@ct/alert";

export default Vue.extend({
  name: "GroupsAttendance",
  components: { SessionAttendance, AlertBar },
  props: {
    id: String
  },
  apollo: {
    registrations: {
      query: REGISTRATION_QUERY,
      variables(): RegistrationQueryVariables {
        return {
          groupId: this.id
        };
      }
    }
  },
  data() {
    return {
      registrations: [] as RegistrationQuery_registrations[]
    };
  },
  computed: {
    orientationItems(): RegistrationQuery_registrations[] {
      return this.registrations.filter(registration => registration.session?.name === "Orientation");
    },
    focusingItems(): RegistrationQuery_registrations[] {
      return this.registrations.filter(registration => registration.session?.name === "Focusing the Mind");
    },
    shiftingItems(): RegistrationQuery_registrations[] {
      return this.registrations.filter(registration => registration.session?.name === "Shifting Emotions");
    },
    connectingItems(): RegistrationQuery_registrations[] {
      return this.registrations.filter(
        registration => registration.session?.name === "Connecting with the Physical Body"
      );
    },
    creatingItems(): RegistrationQuery_registrations[] {
      return this.registrations.filter(registration => registration.session?.name === "Creating Your Vision for Life");
    },
    nextItems(): RegistrationQuery_registrations[] {
      return this.registrations.filter(registration => registration.session?.name === "What's Next and Connect");
    }
  }
});
